import React from "react";
import Tabs from '../Tabs/Tabs';
import AutoPriceRulePresenterWorkspace from "./AutoPriceRulePresenterWorkspace";
import ModalButtons from "../ModalButtons/ModalButtons";
import { parseISO } from 'date-fns';

class AutoPriceRulePresenter extends React.Component {

  constructor(props) {
    super(props)
    
    const pace_array = 
    [
      {pace_selector: 'very_behind_pace', 
      color: "#CC0000", 
      percentage: "-(67%-100%)",
      id: 1,
      order:1},
  
      {pace_selector: 'slightly_behind_pace',
      color: "#FF3300",
      percentage: "-(34%-66%)",
      id: 2,
      order:2},
  
      {pace_selector: 'behind_pace',
      color: "#FF6600",
      percentage: "-(1%-33%)",
      id: 3,
      order:3},
  
      {pace_selector: 'on_pace',
      color: "#FFCC00",
      percentage: "(0%)",
      id: 4,
      order:4},
  
      {pace_selector: 'slightly_ahead_of_pace',
      color: "#33CC33",
      percentage: "+(1%-33%)",
      id: 5,
      order:5},
  
      {pace_selector: 'ahead_of_pace',
      color: "#339933",
      percentage: "+(34%-66%)",
      id: 6,
      order:6},
  
      {pace_selector: 'very_ahead_of_pace',
      color: "#336633",
      percentage: "+(67%-100%)",
      id: 7,
      order:7}
    ]
  const occupancy_array = 
    [
      {
        id: 1,
        occupancy_percentage: (1/9),
        occupancy_comparator: "less_than_or_equal_to",
        order: 1,
        color: "#CC0000", 
      },
      {
        id: 2,
        occupancy_percentage: (2/9),
        occupancy_comparator: "less_than_or_equal_to",
        order: 2,
        color: "#FF3300",
      },
      {
        id: 3,
        occupancy_percentage: (3/9),
        occupancy_comparator: "less_than_or_equal_to",
        order: 3,
        color: "#FF6600",
      },
      {
        id: 4,
        occupancy_percentage: (4/9),
        occupancy_comparator: "less_than_or_equal_to",
        order: 4,
        color: "#FFCC00",
      },
      {
        id: 5,
        occupancy_percentage: (5/9),
        occupancy_comparator: "greater_than_or_equal_to",
        order: 5,
        color: "#33CC33",
      },
      {
        id: 6,
        occupancy_percentage: (6/9),
        occupancy_comparator: "greater_than_or_equal_to",
        order: 6,
        color: "#339933",
      },
      {
        id: 7,
        occupancy_percentage: (7/9),
        occupancy_comparator: "greater_than_or_equal_to",
        order: 7,
        color: "#336633",
      },
      {
        id: 8,
        occupancy_percentage: (8/9),
        occupancy_comparator: "greater_than_or_equal_to",
        order: 8,
        color: "#336633",
      },
    ]
    this.state = {
      activeTab: 'general',
      loading: false,
      all_room_types: this.props.all_room_types || [],
      room_types: this.props.room_types ? this.props.room_types : [],
      all_rates: this.props.all_rates || [],
      errors: this.props.errors ? this.props.errors : {},
      name: this.props.name,
      code: this.props.code,
      start_date: this.props.start_date ? parseISO(this.props.start_date) : null,
      end_date: this.props.end_date ? parseISO(this.props.end_date) : null,
      begin_days_out: this.props.begin_days_out,
      end_days_out: this.props.end_days_out,
      occupancy_comparator: this.props.occupancy_comparator || null,
      occupancy_percentage: this.props.occupancy_percentage,
      pace_selector: this.props.pace_selector || null,
      rates: this.props.rates || null,
      id: this.props.id || null,
      name: this.props.name,
      read_only: typeof this.props.read_only != 'undefined' ? this.props.read_only : false,
      amount: this.props.amount || null,
      percentage: this.props.percentage || null,
      auto_price_rates: this.props.auto_price_rates && this.props.auto_price_rates.length ? this.props.auto_price_rates :  [],
      status: this.props.status,
      updated_at: this.props.updated_at,
      pace_array: pace_array,
      occupancy_array: occupancy_array,
      auto_price_rules_for_date_range: this.props.dynamic_price_adjustments || this.props.auto_price_rules_for_date_range || [],
      auto_price_type: this.props.auto_price_type || null,
      // Dynamic price specific mappings
      dynamic_price_adjustments: this.props.dynamic_price_adjustments || [],
      property_wide: this.props.property_wide,
      minimum_stay: this.props.minimum_stay,
      created_at: this.props.created_at,
      // Map pace/occupancy flags to auto_price_type
      auto_price_type: this.props.pace ? 'pace' : (this.props.occupancy ? 'occupancy' : null),
    }

    this.onSetActiveTab = this.onSetActiveTab.bind(this);
  }

  componentDidUpdate() {
    var self = this
    $(window).on("automaticPriceRuleSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/automatic_price_rules/${self.props.id}/data`,
      }).done((data) => {
        self.setState({...data});
      })
    });
  }

  render() {
    try {
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: ['data-dismiss="modal"']
        }
      ]

      return (
        <div className="auto-price-rule-builder" ref="root">
          <div className="auto-price-rule">
            <Tabs tabs={this.tabs()} />
            <div className="panel panel-form">
              <AutoPriceRulePresenterWorkspace
                {...this.state}
                date_format={this.props.date_format}
                disabled={this.props.disabled}
                auto_price_rule_id={this.props.id}
                time_format={this.props.time_format}
                // automatic_price_rule_revision_history_path={this.props.dynamic_price_revision_history_path || this.props.automatic_price_rule_revision_history_path}
               />
            </div>
          </div>
          <ModalButtons loading={this.state.loading} buttons={buttons} />
        </div>
      );
    } catch (error) {
      return (
        <div className="auto-price-rule-builder">
          <div className="alert alert-danger">
            <h4>Error rendering component</h4>
            <p>{error.message}</p>
            <pre>{JSON.stringify(this.props, null, 2)}</pre>
          </div>
        </div>
      );
    }
  };

  tabs(){
    if (this.props.historical_view == true){
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.activeTab === 'general' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
        ]
      );
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.activeTab === 'general' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
          // {
          //   tabName: I18n.t('room_types'),
          //   targetName: 'room_types',
          //   classes: this.state.activeTab === 'room_types' ? 'active' : null,
          //   changeHandler: this.onSetActiveTab,
          // },
          // {
          //   tabName: I18n.t('rates'),
          //   targetName: 'rates',
          //   classes: this.state.activeTab === 'rates' ? 'active' : null,
          //   changeHandler: this.onSetActiveTab,
          // },
          // {
          //   tabName: I18n.t('history'),
          //   targetName: 'history',
          //   classes: this.state.activeTab === 'history' ? 'active' : null,
          //   changeHandler: this.onSetActiveTab,
          // },
        ]
      );
    }
  }

  onSetActiveTab(name) {
    this.setState({activeTab: name});
  };

};

export default AutoPriceRulePresenter
